<template>
    <nav class="menu-container">

      <RouterLink
        :exact="item.exact"
        v-for="item in items"
        :key="item.link"
        :to="{ name: item.name }"
        active-class="selected"
        exact-active-class=""
      >
        <div class="icon">
          <Icon :type="item.icon" />
        </div>
        <span>{{ item.title }}</span>
      </RouterLink>
      机场北站<br>
站点介绍<br>
机场北站位于宝安区机场九道附近，该站为地下站。<br><br>
运营时刻表(工作日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
岗厦北	06:05	23:58	11号线	4分钟	6分32秒<br>
碧头	06:25	00:09	11号线	4分钟	6分32秒<br>
机场北站	－	－	20号线	7分钟	9分钟-13分26秒<br>
会展城站	07:00	22:00	20号线	7分钟	9分钟-13分26秒<br><br>
运营时刻表(休息日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
岗厦北	06:05	23:58	11号线	4分34秒	6分钟<br>
碧头	06:25	00:09	11号线	4分34秒	6分钟<br>
机场北站	－	－	20号线	7分钟	9分钟-13分26秒<br>
会展城站	07:00	22:00	20号线	7分钟	9分钟-13分26秒<br><br>
运营时刻表(节假日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
岗厦北	06:05	23:58	11号线	4分37秒	6分钟<br>
碧头	06:25	00:09	11号线	4分37秒	6分钟<br>
机场北站	－	－	20号线	7分钟	9分钟-13分26秒<br>
会展城站	07:00	22:00	20号线	7分钟	9分钟-13分26秒<br><br>

站点出口信息<br><br>
D出入口:<br>
新航站楼施工工地，开发中<br><br>
E出入口:<br>
新航站楼施工工地，开发中<br><br>
A出入口:<br>
暂未开通<br><br>
B出入口:<br>
暂未开通<br><br>
C出入口:<br>
暂未开通<br>
穗深城际铁路换乘口:<br>
穗深城际铁路深圳机场北站<br><br>
公交换乘信息<br><br>
B出入口:<br>
公交站名： 炳坑村站<br>
M322、M357、M374、M447、M458、M466<br><br>
C出入口:<br>
公交站名： 炳坑村站<br>
M322、M357、M374、M447、M458、M466<br><br>
D出入口:<br>
公交站名： 炳坑西区站<br>
M220、M303、M304（龙东方向）、M308、M394<br><br>
E出入口:<br>
公交站名： 炳坑西区站<br>
M220、M303、M304（（爱联方向））、M308、M394<br>
  </nav>
  </template>

  <script>
  // import Icon from "@/components/Icon";
  export default {
    components: {
      // Icon,
    },
    data() {
      return {
        items: [
          {
            name: "shiyihaoxian",
            title: "11号线",
            // icon: "chat",
            exact: true,
          },
          {
            name: "ershihaoxian",
            title: "20号线",
            // icon: "chat",
            exact: true,
          },
        ],
      };
    },
  };
  </script>

  <style scoped lang="less">
  @import "~@/styles/var.less";
  .menu-container {
    color: @words;
    margin: 24px 0;
    a {
      &.selected {
        background: darken(@words, 3%);
      }
      padding: 0 50px;
      display: block;
      display: flex;
      align-items: center;
      height: 45px;
      // .icon {
      //   width: 24px;
      // }
      &:hover {
        color: rgb(50, 95, 227);
      }
    }
  }
  </style>